/**
 * @desc 接口导入
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ApiImportRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/api/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
